function initScheduleMobile() {
	if ( $(window).width() < 768 ) {
		var totalHeight = $('.schedule-mobile .weekday[data-weekday="monday_planning"]').outerHeight();
		$('.schedule-mobile').height( totalHeight );
	}

	$('.schedule-mobile__nav').stick_in_parent();


	$('.session__filter-container select').on('change', function(e) {
		getSessionCurrentFilter();
	});
}

function initSchedule() {
	$('.schedule-mobile__nav a').on('click', function() {
		$('.schedule-mobile__nav a').removeClass('current');
		$(this).addClass('current');

		var current_weekday = $(this).data('weekday');
		var schedule_nav_height = $('.schedule-mobile__nav').outerHeight();

		$('html, body').animate({ scrollTop : $('.schedule-mobile').offset().top - schedule_nav_height }, 400 );

		$('.weekday').addClass('weekday--hidden');
		$('.weekday').each(function() {
			if ( $(this).data('weekday') === current_weekday ) {
				$('.schedule-mobile').animate({ height : $(this).outerHeight() }, 400 );
				$(this).removeClass('weekday--hidden');
			}
		});
	});

	if ( $('#filter-period').length > 0 ) {
		$('#filter-period').change( function() {
			var current = $(this).val();

			$('.schedule__body').attr( 'data-period', current );

			if ( current === 'am' || current === 'full' ) {
				$('#schedule').animate({ scrollLeft: 0 }, 700 );
			}

			if ( current === 'noon' ) {
				$('#schedule').animate({ scrollLeft: 5 * 120 }, 700 );
			}

			if ( current === 'pm' ) {
				$('#schedule').animate({ scrollLeft: 7 * 120 }, 700 );
			}

			if ( current === 'night' ) {
				$('#schedule').animate({ scrollLeft: 11 * 120 }, 700 );
			}
		});
	}

	if ( $('#filter-category').length > 0 ) {
		$('#filter-category').change( function() {

			var current = $(this).val();

			if ( current === 'all' ) {
				$('.schedule__item').removeClass('schedule__item--hidden');
			} else {
				$('.schedule__item').addClass('schedule__item--hidden');
				$('.schedule__item').each(function() {
					if ( $(this).data('category').indexOf(current) >= 0  ) {
						$(this).removeClass('schedule__item--hidden');
					}
				});
			}
		});
	}

	if ( $( '#schedule' ).length > 0 ) {
		$('#schedule').scrollLeft(1200);
	}

	$( '.schedule_anim' ).on('click', function() {
		$(this).addClass('schedule_anim--hidden');
	});

	$( '.schedule_prev' ).on( 'click', function() {
		var leftPos = $('#schedule').scrollLeft();
		$("#schedule").animate({
			scrollLeft: leftPos - 120
		}, 300);
	});

	$( '.schedule_next' ).on( 'click', function() {
		var leftPos = $('#schedule').scrollLeft();
		$("#schedule").animate({
			scrollLeft: leftPos + 120
		}, 300);
	});

	initIcsDownload();
}

function getSessionCurrentFilter() {
	var currentCat  = $('.session__cat_filter select').val();

	//console.log( 'filtre actif > ' + currentCat + " - " + currentCity);
	$('.session--no-result').addClass('hidden');

	if ( currentCat == 'all' ) {

		$('.weekday li').removeClass('hidden');
		$('.session--no-result').addClass('hidden');
		return;

	} else {

		$('.weekday li').addClass('hidden');

		var itemCat  = "";
		var isFull   = false;

		$('.weekday li').each( function(index) {
			itemCat  = $(this).attr('class');

			console.log( index + " > " + itemCat );

			if ( $(this).hasClass( currentCat ) || currentCat == 'all' ) {
				$(this).removeClass('hidden');
				isFull = true;
			}
		});

		if ( isFull == false ) {
			$('.session--no-result').removeClass('hidden');
		}
	}
}

function getNextDayOfWeek(date, dayOfWeek) {
	// Code to check that date and dayOfWeek are valid left as an exercise ;)
	var resultDate = new Date(date.getTime());
	var delta = (7 + dayOfWeek - date.getDay()) % 7;

	if(delta === 0){
		delta = 7;
	}

	resultDate.setDate(date.getDate() + delta);

	return resultDate;
}

function pad(n) {
	return n<10 ? '0'+n : n;
}

function initIcsDownload() {
	$('.dl-ics').on('click', function(e) {
		e.preventDefault();

		var currentDayForDatetime = new Date().getDay();
		var currentDay = currentDayForDatetime - 1;
		if (currentDay < 0 ) {
			currentDay = 6;
		}

		var day = parseInt($(this).data('day'));
		var hour = parseInt($(this).data('hour'));
		var minute = parseInt($(this).data('minute'));
		var duration = parseInt($(this).data('duration'));
		var dateStart;
		var dateEnd;
		var activityDate;
		var startYear;
		var startMonth;
		var startDay;
		var startHours;
		var startMinutes;
		var endHours;
		var endMinutes;

		var dayForDatetime = day + 1;
		if (dayForDatetime > 6) {
			dayForDatetime = 0;
		}

		// Si jour courant et cours au moins 1h dans le futur
		if (currentDay === day) {
			activityDate = new Date();
			activityDate.setHours(hour, minute);

			if (((activityDate.getTime() - new Date().getTime()) / 1000) > 3600) {
				startDateDatetime = activityDate;
			} else {
				startDateDatetime = getNextDayOfWeek( activityDate, dayForDatetime);
			}
		} else {
			// définir la date de la prochaine occurence du jour de la semaine cliqué
			activityDate = getNextDayOfWeek( new Date(), dayForDatetime);
			// On ajuste l'horaire du cours
			activityDate.setHours(hour, minute);

			startDateDatetime = activityDate;
		}

		// Extraction des valeurs de la date pour créer un timestamp au format compatible iCal
		startYear = startDateDatetime.getFullYear();
		startMonth = startDateDatetime.getMonth();
		startDay = startDateDatetime.getDate();
		startHours = startDateDatetime.getHours();
		startMinutes = startDateDatetime.getMinutes();

		// Génération du dateUTC
		dateStart = startYear + '' + pad(startMonth + 1) + '' +  pad(startDay) + "T" + pad(startHours) + '' +  pad(startMinutes) + '' +  "00";

		// Timestamp de la fin du cours, on ajoute la durée au timestamp de début.
		dateEndDateTime = new Date(startDateDatetime.getTime() + duration*60000);
		endHours = dateEndDateTime.getHours();
		endMinutes = dateEndDateTime.getMinutes();

		dateEnd = startYear + '' + pad(startMonth + 1) + '' + pad(startDay) + "T" + pad(endHours) + '' + pad(endMinutes) + '' + "00";

		$('#form-download-ics input[name="date_start"]').val(dateStart);
		$('#form-download-ics input[name="date_end"]').val(dateEnd);
		$('#form-download-ics input[name="duration"]').val(duration);
		$('#form-download-ics input[name="location"]').val($(this).data('location'));
		$('#form-download-ics input[name="description"]').val($(this).data('description'));
		$('#form-download-ics input[name="summary"]').val($(this).data('summary'));
		$('#form-download-ics').submit();

		return false;
	});
}


